import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SessionService } from '@core/services';
import { CustomEncoder } from './custom-encoder';

@Injectable()
export class AddTokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly sessionService: SessionService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = new HttpParams({ encoder: new CustomEncoder(), fromString: request.params.toString() });
    const authReq = request.clone({
      headers: new HttpHeaders({
        Authorization: `bearer ${this.sessionService.getAccessToken()}`
      }),
      params
    });
    return next.handle(authReq);
  }
}
